<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("state.title") }}</h1>
    <div class="m-4">
      <table :fields="fields" :items="items" class="fc-andon-all">
        <thead class="fc-andon-all thead">
          <tr>
            <th></th>
            <td>{{ $i18n.t("state.label_make_count_complete") }}</td>
            <td>{{ $i18n.t("state.label_ng_count") }}</td>
            <td>{{ $i18n.t("state.label_stock_count") }}</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in items" :key="index">
            <th>
              <u>
                <b-link @click="linkToLineState(row.lineId)">{{row.lineName}}</b-link>
              </u>
            </th>
            <td>{{row.make}}</td>
            <td>{{row.ng}}</td>
            <td>{{row.stock}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'
export default {
  components: {
    confirmModal
  },
  data () {
    return {
      intervalId: undefined,
      errMsgShow: false,
      errMsg: null,
      errSbj: null,
      fields: [
        { key: 'lineName', label: '' },
        { key: 'make', label: '製造数' },
        { key: 'ng', label: '不良数' },
        { key: 'stock', label: '在庫' }
      ],
      items: [
      ]
    }
  },
  created: async function () {
    // 全ライン取得
    // 日付取得
    var dates = await this.getSearchDate()

    var reqObj = {}
    reqObj.start = String(dates.start)
    reqObj.end = String(dates.end)

    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    await this.$axios
      .post(window.END_POINT + '/state/allLine', reqObj, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            if (this.errMsgShow === false) {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
              this.errMsgShow = true
            }
          }
        } else {
          var dataList = res.data.lineList
          if (dataList.length === 0) {
            // 本日の製造は開始されていません
            this.errSbj = this.$i18n.t('state.title')
            this.errMsg = this.$i18n.t('state.not_started_yet')
            this.$bvModal.show('md-err')
            this.errMsgShow = true
          }
          var datas = []
          // 整形
          for (var i = 0; i < dataList.length; i++) {
            var data = {}
            data.lineId = dataList[i].line_id
            data.lineName = dataList[i].line_name
            data.make = dataList[i].make_count
            data.ng = dataList[i].ng_count
            data.stock = dataList[i].stock_count
            datas.push(data)
          }

          // 一旦データクリア
          this.items.splice(0)
          // データセット
          this.items.splice(0, 0, ...datas)
        }
      })
      .catch(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        if (this.errMsgShow === false) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          this.errMsgShow = true
        }
        console.log(res)
      })

      // 1分ごとに定期実行するよう設定
    this.intervalId = window.setInterval(this.getStates, 60000)
  },
  methods: {
    getStates: async function () {
      // 日付取得
      var dates = await this.getSearchDate()
      var reqObj = {}
      reqObj.start = String(dates.start)
      reqObj.end = String(dates.end)

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/state/allLine', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              if (this.errMsgShow === false) {
                this.errSbj = this.$i18n.t('common.title_modal_error')
                this.errMsg = this.$i18n.t(res.data.message)
                this.$bvModal.show('md-err')
                this.errMsgShow = true
              }
            }
          } else {
            var dataList = res.data.lineList
            var datas = []
            // 整形
            for (var i = 0; i < dataList.length; i++) {
              var data = {}
              data.lineId = dataList[i].line_id
              data.lineName = dataList[i].line_name
              data.make = dataList[i].make_count
              data.ng = dataList[i].ng_count
              data.stock = dataList[i].stock_count
              datas.push(data)
            }
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.items.splice(0, 0, ...datas)
            // 正常にデータ取得できたので、エラー表示フラグリセット
            this.errMsgShow = false
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (this.errMsgShow === false) {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t('common.unexpected_error')
            this.$bvModal.show('md-err')
            this.errMsgShow = true
          }
          console.log(res)
        })
    },
    getSearchDate: async function () {
      var startTime = ''
      var dates_ = []
      // 開始時間取得
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      await this.$axios
        .post(window.END_POINT + '/common/selectStartTime', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              if (this.errMsgShow === false) {
                this.errSbj = this.$i18n.t('common.title_modal_error')
                this.errMsg = this.$i18n.t(res.data.message)
                this.$bvModal.show('md-err')
                this.errMsgShow = true
              }
            }
          } else {
            startTime = res.data.shift_start_time
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (this.errMsgShow === false) {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t('common.unexpected_error')
            this.$bvModal.show('md-err')
            this.errMsgShow = true
          }
          console.log(res)
        })

      // 日またぎ確認、時間取得
      var nowTime = window.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
      dates_ = window.getStartTime(startTime, nowTime, true)

      var dates = []
      // 作業開始時間をUTCに変換
      var startLocal = this.setUTCDate(dates_.start, 'YYYY/MM/DD hh:mm:ss')
      var obj = this.$moment(startLocal, 'YYYY/MM/DD HH:mm:ss')
      var utcStrStart = obj.utc().format('YYYY/MM/DD HH:mm:ss')
      dates.start = utcStrStart

      // 現在時刻をUTCに変換
      var endLocal = this.setUTCDate(dates_.end, 'YYYY/MM/DD hh:mm:ss')
      var objEnd = this.$moment(endLocal, 'YYYY/MM/DD HH:mm:ss')
      var utcStrEnd = objEnd.utc().format('YYYY/MM/DD HH:mm:ss')
      dates.end = utcStrEnd

      return dates
    },
    setUTCDate: function (date, format) {
      if (!format) {
        // デフォルト値
        format = 'YYYY/MM/DD hh:mm:ss'
      }
      // フォーマット文字列内のキーワードを日付に置換する
      format = format.replace(/YYYY/g, date.getFullYear())
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2))
      format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2))
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2))
      return format
    },
    linkToLineState: function (lineId) {
      var path = '/stateline'
      this.$router.push({ path: path, query: {lineId: [lineId]} })
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  },
  destroyed: function () {
    clearInterval(this.intervalId)
  },
  routes: [
    {
      path: '/stateline/:lineid',
      name: 'stateline',
      components: './StateLine.vue'
    }
  ]
}
</script>

<style scoped>
.fc-andon-all {
  width: 100%;
  border-collapse: collapse;
  line-height: 1;
}

.fc-andon-all thead td {
  border: 3px solid #999;
  background-color: rgba(255, 255, 255, 0.05);
  font-size: calc(24px + 2vw);
  text-align: center;
  padding: 20px;
}

.fc-andon-all tbody th {
  border: 3px solid #999;
  background-color: rgba(255, 255, 255, 0.05);
  font-size: calc(24px + 1vw);
  font-weight: normal;
  padding: 20px;
}

.fc-andon-all tbody td {
  border: 3px solid #999;
  font-size: calc(24px + 5vw);
  text-align: right;
  padding: 40px 20px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/State.vue